module.exports = __webpack_public_path__ + "static/media/Session_Expired_Image@3x.8a6bf9ff.png";